import { useState } from 'react';
import {
    CONFIRM_REQUEST_LABEL,
    CONFIRM_WARNING,
    CONFIRM_KEEP_LABEL,
    CONFIRM_SEND_LABEL,
    ACTION_BUTTON_CLASSES,
} from '../vacationRequestDetailsModal.definitions';

export interface ConfirmRequestActionProps {
    onConfirm: () => void;
    isConfirming: boolean;
    compact?: boolean;
    isOpen?: boolean;
    onOpenChange?: (open: boolean) => void;
    showWarning?: boolean;
}

export function ConfirmRequestAction({
    onConfirm,
    isConfirming: isLoading,
    compact = false,
    isOpen: controlledOpen,
    onOpenChange,
    showWarning = true,
}: ConfirmRequestActionProps) {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
    const isOpen = controlledOpen !== undefined ? controlledOpen : uncontrolledOpen;
    const setOpen = (newOpen: boolean) => {
        if (controlledOpen !== undefined) {
            onOpenChange?.(newOpen);
        } else {
            setUncontrolledOpen(newOpen);
        }
    };

    const buttonSizeClasses = compact ? ACTION_BUTTON_CLASSES.compact : ACTION_BUTTON_CLASSES.normal;
    const warningClasses = compact ? ACTION_BUTTON_CLASSES.compactWarning : ACTION_BUTTON_CLASSES.normalWarning;

    if (!isOpen) {
        return (
            <button
                type="button"
                onClick={() => setOpen(true)}
                className={`rounded-xl border border-primary-200 bg-primary-600 text-white font-semibold transition-colors hover:bg-primary-700 font-montserrat whitespace-nowrap ${buttonSizeClasses}`}
            >
                {CONFIRM_REQUEST_LABEL}
            </button>
        );
    }

    return (
        <div className="flex flex-col items-end gap-2 sm:flex-row sm:items-center">
            {showWarning && (
                <p className={`text-primary-700 font-montserrat ${warningClasses}`}>{CONFIRM_WARNING}</p>
            )}
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => setOpen(false)}
                    disabled={isLoading}
                    className={`rounded-xl border border-gray-200 bg-white font-semibold text-raro-gray-700 transition-colors hover:bg-gray-50 font-montserrat whitespace-nowrap ${buttonSizeClasses}`}
                >
                    {CONFIRM_KEEP_LABEL}
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isLoading}
                    className={`rounded-xl border border-transparent bg-primary-600 font-semibold text-white transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-60 font-montserrat whitespace-nowrap ${buttonSizeClasses}`}
                >
                    {CONFIRM_SEND_LABEL}
                </button>
            </div>
        </div>
    );
}

export default ConfirmRequestAction;
